import { createReducer } from '@reduxjs/toolkit';

import {
  setControl,
  setControls,
  resetControls,
  createUser,
  createUserSuccess,
  createUserFail,
} from './register.actions';

const initialState = {
  controls: {
    name: '',
    email: '',
    password: '',
    repeatPassword: '',
  },
  loading: false,
  message: '',
};

const RegisterReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setControl, (state, { payload }) => {
      state.controls = { ...state.controls, ...payload };
    })
    .addCase(setControls, (state, { payload }) => {
      state.controls = { ...state.controls, ...payload };
    })
    .addCase(resetControls, (state) => {
      state.controls = { ...initialState.controls };
    })
    .addCase(createUserSuccess, (state) => {
      state.controls = { ...initialState.controls };
      state.loading = false;
    })
    .addCase(createUser, (state) => {
      state.loading = true;
    })
    .addCase(createUserFail, (state) => {
      state.loading = false;
    });
});

export default RegisterReducer;
